import { Language } from '../../../enums/const-enums';

export interface RassNotificationTranslations {
  notifications: {
    SCANNERLESS: {
      header: string;
      body: string;
    };
  };
}

const nlTranslations: RassNotificationTranslations = {
  notifications: {
    SCANNERLESS: {
      header: 'Veilig bankieren zonder Rabo Scanner?',
      body: 'Zoek in de Rabo app op "Bankieren zonder scanner"!',
    },
  },
};

const enTranslations: RassNotificationTranslations = {
  notifications: {
    SCANNERLESS: {
      header: 'Safe banking without Rabo Scanner?',
      body: 'Search in the Rabo app for "Banking without a scanner"!',
    },
  },
};

export const rassNotificationTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
